import { combineReducers } from 'redux';

import organizationList from './requests/organizations-req';
import locationList from './requests/locations-req';
import paymentList from './requests/payments-req';

export default combineReducers({
  organizationList,
  locationList,
  paymentList,
});



// WEBPACK FOOTER //
// ./src/redux/payment-methods/index.js